<template lang="pug">
.container
  .background-image(:style="{ backgroundImage: 'url(/static/bg/' + currentPhoto.file + ')' }")
  .background-dim
  .status-changing-network
    .logo-network
    .title {{ $t('LOADING NETWORK DATA')}}
    .network {{ this.$store.state.User.user.Networks.find(network => network.id === this.$store.state.User.user.lastNetworkId).name }}
    .description
      .media-description(v-if='this.$store.state.User.changing_network_status_media') {{ $t(this.$store.state.User.changing_network_status_media) }}
      .devices-description(v-if='this.$store.state.User.changing_network_status_devices') {{ $t(this.$store.state.User.changing_network_status_devices) }}
</template>

<script>
export default {
  beforeMount () {
    this.currentPhoto = this.photos[Math.floor(Math.random() * this.photos.length)]
  },
  data () {
    return {
      currentPhoto: undefined,
      photos: [
        {
          file: 'cassie-matias--lpbnspYkJg-unsplash.jpg',
          credit: 'Photo by Cassie Matias on Unsplash'
        },
        {
          file: 'ines-alvarez-fdez-u6rZ2_bUgUE-unsplash.jpg',
          credit: 'Photo by Ines Alvarez on Unsplash'
        },
        {
          file: 'james-pritchett-cqdl_0gQY1M-unsplash.jpg',
          credit: 'Photo by James Pritchett on Unsplash'
        },
        {
          file: 'jeremy-bishop-llkPqjQTeok-unsplash.jpg',
          credit: 'Photo by Jeremy Bishop on Unsplash'
        },
        {
          file: 'jeremy-bishop-uBHSWYWZT7A-unsplash.jpg',
          credit: 'Photo by Jeremy Bishop on Unsplash'
        },
        {
          file: 'lance-asper-n3cVKwAugtc-unsplash.jpg',
          credit: 'Photo by Lance Asper on Unsplash'
        },
        {
          file: 'antonio-pina-IbjSKhO1xXI-unsplash.jpg',
          credit: 'Photo by Antonio Pina on Unsplash'
        },
        {
          file: 'atte-gronlund-zS2iq9zU3sc-unsplash.jpg',
          credit: 'Photo by Atte Gronlund on Unsplash'
        },
        {
          file: 'carl-j-jcSiJ3JQ5QY-unsplash.jpg',
          credit: 'Photo by Carl J on Unsplash'
        },
        {
          file: 'chris-grafton-dLhGAvFdmcc-unsplash.jpg',
          credit: 'Photo by Chris Grafton on Unsplash'
        },
        {
          file: 'george-desipris-svEN_5NXO3o-unsplash.jpg',
          credit: 'Photo by George Desipris on Unsplash'
        },
        {
          file: 'george-desipris-sXzuRmorw7o-unsplash.jpg',
          credit: 'Photo by George Desipris on Unsplash'
        },
        {
          file: 'james-peacock-BDATv21bg9M-unsplash.jpg',
          credit: 'Photo by James Peacock on Unsplash'
        },
        {
          file: 'james-peacock-vOWaLcUCJIM-unsplash.jpg',
          credit: 'Photo by James Peacock on Unsplash'
        },
        {
          file: 'ludomil-lsXbZtrVSdQ-unsplash.jpg',
          credit: 'Photo by Ludomil on Unsplash'
        },
        {
          file: 'marcus-dall-col-5rh8fzL0hI8-unsplash.jpg',
          credit: 'Photo by Marcus Dall Col on Unsplash'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.status-changing-network {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  z-index: 3003;
  .logo-network {
    height: 37px;
    width: 170px;
    margin-bottom: 10px;
    cursor: pointer;
    background: url('/static/wave2-logo.svg') 100% no-repeat;
    background-size: contain;
  }
  .description {
    // color: $--color-success-light;
    font-size: $--font-size-small;
    height: 100px;
  }
  .title {
    color: $--color-text-secondary;
    font-size: 7px;
    // font-weight: bold;
  }
  .network {
    color: $--color-warning;
    margin: 50px 0px 17px 0px;
    font-size: $--font-size-image-30;
    font-weight: bold;
  }
}
.background-image {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 3001;
  background-size: cover;
  filter: blur(10px);
  -webkit-filter: blur(10px);
}
.background-dim {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 3002;
  background-color: $--color-white;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutComponents/ChangingNetwork.vue